import { DropdownMenuItem } from 'design-system';

import { getConversationLabel } from '@/features/ai-chat/lib/conversationLabel';
import type { Conversation } from '@/features/ai-chat/types/chat.types';

import { useHistoryRecord } from './useHistoryRecord';

const HistoryRecord = ({
  conversation,
  handleClose,
  index
}: {
  conversation: Conversation;
  handleClose: () => void;
  index: number;
}) => {
  const { timeAgo, handleClick } = useHistoryRecord(conversation, handleClose);

  return (
    <DropdownMenuItem
      className='h-10'
      onClick={handleClick}
    >
      <div className='flex w-full items-center justify-between gap-2'>
        <span
          className='min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap'
          title={conversation.name}
        >
          {getConversationLabel(conversation, index)}
        </span>
        <span className='shrink-0 text-[10px] leading-none text-gx-text-disabled'>
          {timeAgo} ago
        </span>
      </div>
    </DropdownMenuItem>
  );
};

export default HistoryRecord;
